import { Stack, Typography } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { Button } from '~/shared/ui/Buttons'
import { Modal } from '~/shared/ui/Modal'

type FreeContractTypeConfirmModalProps = {
  isShow: boolean
  onCancel: () => void
  onConfirm: () => void
  isSubmitting?: boolean
}

export function FreeContractTypeConfirmModal({
  isShow,
  onCancel,
  onConfirm,
  isSubmitting = false,
}: FreeContractTypeConfirmModalProps) {
  const { t } = useTranslation()

  return (
    <Modal
      isShow={isShow}
      onCancel={!isSubmitting ? onCancel : undefined}
      title={t('alert.confirm price')}
      dialogProps={{
        sx: {
          minWidth: '600px',
          maxWidth: '600px',
        },
      }}
    >
      <Typography
        sx={{
          marginBottom: '24px',
        }}
      >
        {t('alert.rental contract free type')}
      </Typography>

      <Stack direction='row' justifyContent='space-between' spacing={2}>
        <Button
          variant='gray'
          fullWidth
          onClick={onCancel}
          disabled={isSubmitting}
        >
          {t('button.cancel')}
        </Button>
        <Button
          variant='brand'
          fullWidth
          onClick={onConfirm}
          loading={isSubmitting}
        >
          {t('button.accept')}
        </Button>
      </Stack>
    </Modal>
  )
}
